/**
 * 浏览器UA
 * @hidden
 */
var userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
var UA = {
    /**
     * 安卓
     */
    isAndroid: /Android/i.test(userAgent),
    /**
     * iOS
     */
    isiOS: /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(userAgent),
    /**
     * 九游客户端
     */
    isNG: /ninegameclient/i.test(userAgent),
    /**
     * 九游联运SDK
     */
    isNGSdk: /ucsdk/i.test(userAgent),
    /**
     * 九游客户端-安卓
     */
    isNGAndroid: /ninegameclient\/android/i.test(userAgent),
    /**
     * 九游客户端-iOS
     */
    isNGiOS: /ninegameclient\/ios/i.test(userAgent),
    /**
     * UC内核
     */
    isUC: /UCBrowser/i.test(userAgent),
    /**
     * 微信
     */
    isWechat: /MicroMessenger/i.test(userAgent),
    /**
     * 微博
     */
    isWeiBo: /WeiBo/i.test(userAgent),
    /**
     * 钉钉
     */
    isDingTalk: /DingTalk/i.test(userAgent),
};
export { UA };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/fast-utils/dist/ua.js
// module id = null
// module chunks = 